<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
    martin vicencio benkohanck
========================================================================================== -->

<template>
  <vx-card title="Alumnos" code-toggler>

<!-- Formulario agregar alumno -->
                <vs-popup fullscreen class="holamundo" title="" :active.sync="formModalAlumno" >
                    <vx-card title="">   
                        <!-- CAMPOS -->
                        <form>
                            <vs-input name="id" type="hidden" :value="formAlumno.id" v-model="formAlumno.id"  />
                            <div class="container">
                                
                                <div class="row">
                                  <div class="alert alert-warning" role="alert">Datos personales</div>      

                                    <!-- <div class="centerx">
    <vs-upload action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" />
  </div>  -->

                       
                                    <div class="col-3">Matricula
                                      <vs-input v-validate="'required'"  name="matricula" :disabled="formAlumno.id" type="number" v-model="formAlumno.matricula" />
                                       <span class="text-danger text-sm" v-show="errors.has('matricula')">{{ errors.first('matricula') }}</span>
                                    </div>
                                 <div class="col-3">Nombre
                                        <vs-input v-validate="'required'" placeholder="Nombre" name="nombres" v-model="formAlumno.nombres" />
                                    <span class="text-danger text-sm" v-show="errors.has('nombres')">{{ errors.first('nombres') }}</span>
                                    </div>


                                <!-- </div>

                                <div class="row"> -->
                                    <div class="col-3">Apellido paterno
                                        <vs-input v-validate="'required'" placeholder="Apellido Paterno" name="apellidoPaterno" v-model="formAlumno.apellidoPaterno" />
                                    <span class="text-danger text-sm" v-show="errors.has('apellidoPaterno')">{{ errors.first('apellidoPaterno') }}</span>
                                    </div>
                                  <div class="col-3">Apellido materno
                                        <vs-input v-validate="'required'" placeholder="Apellido Materno" name="amaterno" v-model="formAlumno.apellidoMaterno" />
                                    <span class="text-danger text-sm" v-show="errors.has('ApellidoMaterno')">{{ errors.first('ApellidoMaterno') }}</span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-3">Genero
                                        <!-- <vs-input v-validate="'required'" placeholder="Correo" name="correo" v-model="formAlumno.correo" />
                                    <span class="text-danger text-sm" v-show="errors.has('correo')">{{ errors.first('correo') }}</span> -->
                                     <vs-select v-validate="'required'" name="sexo" v-model="formAlumno.sexo" >
                                     <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in options1" />
                                      </vs-select>
                                      <span class="text-danger text-sm" v-show="errors.has('sexo')">{{ errors.first('sexo') }}</span>
                                    
                                    </div>
                                    <div class="col-3">NSS
                                    <vs-input  type="number"  name="nss" v-model="formAlumno.nss" />
                                    <!-- <span class="text-danger text-sm" v-show="errors.has('nss')">{{ errors.first('nss') }}</span> -->
                                    </div>
                                <!-- </div>
                                  <div class="row"> -->
                                   <div class="col-3">CURP
                                    <vs-input v-validate="'required'" placeholder="curp" name="curp" v-model="formAlumno.curp" />
                                    <span class="text-danger text-sm" v-show="errors.has('curp')">{{ errors.first('curp') }}</span>
                                    </div>
                                    <div class="col-3">Contraseña
                                        <vs-input placeholder="contraseña" name="contrasegna" type="password" v-model="formAlumno.contrasegna" class="mt-5" />
                                        <!-- <span class="text-danger text-sm" v-show="errors.has('contrasegna')">{{ errors.first('contrasegna') }}</span> -->
                                    </div> 
                                  </div>        
                                    <div class="row">                      
                                    <div class="col">Carrera
                                        <v-select v-validate="'required'" style="width: 100%;" label="nombre" name="idCarrera" v-model="formAlumno.idCarrera" :options="carreras"></v-select>
                                        <span class="text-danger text-sm" v-show="errors.has('idCarrera')">{{ errors.first('idCarrera') }}</span>
                                    </div>
                                </div>
<br>
                                <div class="row">
                                  <div class="col">
                                     <div class="alert alert-warning" role="alert">Domicilio</div>
                                  </div>
                                </div>

                                  <div class="row">
                                   <div class="col-3">Calle
                                    <vs-input placeholder="calle" name="calle" v-model="formAlumno.calle" />
                                    <!-- <span class="text-danger text-sm" v-show="errors.has('calle')">{{ errors.first('calle') }}</span> -->
                                    </div>
                             
                                    <div class="col-3">No.Exterior
                                        <vs-input type="number"  name="numExterior" v-model="formAlumno.numExterior" />
                                    <!-- <span class="text-danger text-sm" v-show="errors.has('numExterior')">{{ errors.first('numExterior') }}</span> -->
                                    </div> 
                                  <!-- </div>        

                             <div class="row"> -->
                                   <div class="col-3">No.Interior
                                    <vs-input  type="number"  name="numInterior" v-model="formAlumno.numInterior" />
                                    <!-- <span class="text-danger text-sm" v-show="errors.has('numInterior')">{{ errors.first('numInterior') }}</span> -->
                                    </div>
                             
                                    <div class="col-3">cp
                                        <vs-input type="number"  name="cp" v-model="formAlumno.cp" />
                                    <!-- <span class="text-danger text-sm" v-show="errors.has('cp')">{{ errors.first('cp') }}</span> -->
                                    </div> 
                              </div>

                              <div class="row">                      
                                    <div class="col">Estado
                                        <v-select style="width: 100%;" label="nombre" name="estado_id" @change="getMunicipio()" v-model="formAlumno.estado_id" :options="estados"></v-select>
                                        <!-- <span class="text-danger text-sm" v-show="errors.has('estado_id')">{{ errors.first('estado_id') }}</span> -->
                                    </div>
                                </div>

                           <div class="row">                      
                                    <div class="col">Municipio
                                        <v-select style="width: 100%;" label="nombre" name="municipio_id"  v-model="formAlumno.municipio_id" :options="municipios"></v-select>
                                        <!-- <span class="text-danger text-sm" v-show="errors.has('municipio_id')">{{ errors.first('municipio_id') }}</span> -->
                                    </div>
                                </div>

                           <div class="row">
                                   <div class="col-3">Tel.Casa   
                                    <vs-input type="number"  name="telCasa" v-model="formAlumno.telCasa" />
                                    <!-- <span class="text-danger text-sm"  v-show="errors.has('telCasa')">{{ errors.first('telCasa') }}</span> -->
                                    </div>
                             
                                    <div class="col-3">Celular
                                        <vs-input v-validate="'required'" type="number" name="telCelular" v-model="formAlumno.telCelular" />
                                    <span class="text-danger text-sm" v-show="errors.has('telCelular')">{{ errors.first('telCelular') }}</span>
                                    </div> 
                              </div>  

                                <div class="row">           
                                    <vs-button type="filled" @click.prevent="submitForm" class="mt-5 block">Guardar</vs-button>
                                </div>  
                            </div> 
                        </form>
                    </vx-card>
                   
                </vs-popup>
            <!-- Termina formulario -->

   <!-- Estatus alumno -->
                <vs-popup class="holamundo" title="Datos del alumno" :active.sync="modalEstatus">
                    <vx-card  title="Estatus del alumno" >
                        <!-- CAMPOS  altura del modal style="height:800px" -->
                            <div class="container">                        
                                <div class="row">
                                      <div class="col">
                                        <vs-list-item title="Matricula:" ></vs-list-item>
                                       
                                            <div class="alert alert-success" role="alert">
                                        {{formEstatus[0].matricula}}
                                          </div>
                                         </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <vs-list-item title="Nombre:"></vs-list-item>
                                        
                                         <div class="alert alert-success" role="alert">
                                         {{formEstatus[0].nombre_completo}}
                                          </div>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                   <vs-list-item title="Carrera:"></vs-list-item>
                                     
                                         <div class="alert alert-success" role="alert">
                                          {{formEstatus[0].carrera}}
                                          </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                         <vs-list-item title="Año de Ingreso:" subtitle=""></vs-list-item>
                                         
                                           <div class="alert alert-success" role="alert">
                                           {{formEstatus[0].anio_ingreso}}
                                          </div>
                                  
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                      <vs-list-item title="Año de Egreso:" subtitle=""></vs-list-item>
                                     
                                      <div class="alert alert-success" role="alert">
                                            {{formEstatus[0].anio_egreso}}
                                          </div>
                                    </div>
                                </div>

                          
                                <div class="row">
                                   <div class="col">
                                        <vs-list-item title="Estatus:" subtitle=""></vs-list-item>
                                        <div class="alert alert-success" role="alert">
                                           {{formEstatus[0].estatus}}
                                          </div>
                                   </div> 
                                </div> 
                               
                            </div>
                        
                    </vx-card>
                   
                </vs-popup>
            <!-- Termina formulario -->

    <!-- <p>Historico de Alumnos</p><br> -->

                        <div style="text-align: right;">
                            <p>
                                    <!-- <vs-button class="" style="margin: 3px;"  @click="agregar()">Agregar </vs-button> -->
                                    
                               </p>
                           </div>

    <vs-table search pagination :maxItems="30" stripe :data="alumnos">

      <template slot="thead">
        <vs-th sort-key="matricula">Matricula</vs-th>
        <vs-th>Curp</vs-th>
        <vs-th>Nombre</vs-th>
        <vs-th>Carrera</vs-th>
        <vs-th>Cuatrimestre</vs-th>
        <vs-th>Estatus</vs-th>
        <vs-th>Kardex</vs-th>
        <!-- <vs-th  colspan="2" style="text-align: center;"> Acciones</vs-th> -->
        

        <!-- <vs-th>Cambio de carrera</vs-th> -->
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].cuenta">
            {{data[indextr].matricula}}
          </vs-td>
          <vs-td :data="data[indextr].curp">
            {{data[indextr].curp}}
          </vs-td>
          <vs-td :data="data[indextr].username">
            {{data[indextr].apellidoPaterno}} {{data[indextr].apellidoMaterno}} {{data[indextr].nombres}}
          </vs-td>
          <vs-td :data="data[indextr].idCarrera">
            {{data[indextr].siglasCarrera}}
          </vs-td>

          <vs-td :data="data[indextr].cuatrimestre">
            {{data[indextr].cuatrimestre}}
          </vs-td>
          <vs-td style="text-align: center;" :data="data[indextr].id">
           <vs-button  color="success" type="line"  icon="visibility"  @click="ver_estatus(data[indextr].id)"></vs-button>
            </vs-td>

          <vs-td style="text-align: center;" :data="data[indextr].id">
           <vs-button  size="large" color="primary"  type="line" icon="event_note"  @click="ver_kardex(data[indextr])"></vs-button>
          </vs-td>
            
          <!-- <vs-td style="text-align: center;" :data="data[indextr].id">
           <vs-button  size="large" color="warning"  type="line" icon="edit"  @click="editar(data[indextr].id)"></vs-button>
           </vs-td> -->
           <!-- <vs-td  style="text-align: center;" :data="data[indextr].id"> -->
            <!-- <vs-button  size="large" color="danger"  type="line" icon="delete_outline"  @click="ver_estatus(data[indextr])"></vs-button> -->
          <!-- </vs-td> -->
          <!-- <vs-td style="text-align:center">
            <a class="btn" href="#"  @click="cambiar_carrera(data[indextr].id)">
              <i class="fa fa-repeat fa-2x" style="color:#0d6efd;" aria-hidden="true"></i>
            </a>
          </vs-td> -->
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select'
    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    import Table from "../ui-elements/table/Table";
    // import DragItDude from "vue-drag-it-dude";
    import Button from "../components/vuesax/button/Button";

export default {
  data() {
    return {
       id_rol: this.getKey('id_rol'),
      carrera: localStorage.getItem('id_carrera'),
      cuatrimestre_actual: [{ nombre: "", idAgno: "" }],
      alumno_detalle: [],
      alumnos: [],
      carreras: [],
      carreras_select: {},
      modalEstatus:false,
      formEstatus: [{}],
      formModalAlumno:false,
      formAlumno:{},
    //  sexo:"",
      options1:[
        {text:'M',value:'M'},
        {text:'H',value:'H'}
      ],
    estados:[],
    municipios:[]


    }
  },

  components: {
            Button,
            Table,
            'v-select': vSelect,
            FormWizard,
            TabContent
            // DragItDude
        },
        
  created() {
    if(this.id_rol == 6){
    this.$vs.loading();
    this.carrera =  localStorage.getItem('id_carrera');
    this.getCuatrimestreActual();
    this.getCarreras();
    this.getAlumnos();
    this.getEstados();
    }

  },
  mounted(){

  },
  watch: {
    // whenever question changes, this function will run

  },
  methods: {

// successUpload(){
//       this.$vs.notify({limit:1,color:'success',title:'Upload Success',text:'Lorem ipsum dolor sit amet, consectetur'})
//     },

   submitForm() {
                this.$validator.validateAll().then(result => {
                    if(result) {
                       let tokenStorage=localStorage.getItem('app-token');

                        this.$http.post("save_alumno",{token:tokenStorage,data:this.formAlumno}).then(
                            response => {
                                if(response.data.resultado==="ok"){ 
                                    this.$vs.notify({ color: 'success', title: 'Registro guardado', text: 'Se guardo el registro correctamente' });
                                    this.formAlumno={};
                                    this.formModalAlumno=false;
                                    this.getAlumnos();

                                }else{
                                    this.$vs.notify({
                                        time: 2500,
                                        title: 'Error',
                                        text: response.data.resultado,
                                        iconPack: 'feather',
                                        icon: 'icon-alert-circle',
                                        color: 'danger'
                                    });
                                }
                                
                            },
                            error => {
                                if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
                                this.$router.push({name:'pageLogin'});
                                localStorage.clear();
                                location.reload()
                                }
                                this.StepError(error);
                            }
                        );
                    }else{
                        // form have errors
                    }
                })
            },

  agregar(){

      // cuando se agrege alumno tambien actualizar el rgistro de academicos como año de ingreso, y estatus del alumno en tipo dos estudiante acivo
      //en el contolador en cuanto se actualice la informacn del alumno 
                this.formAlumno={};
                this.formModalAlumno=true;
            },
  editar(id){
                this.$http.get("get_alumno/"+id).then(
                    response => {
                        this.formAlumno = response.data.alumno;
                        this.formModalAlumno=true;

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },

    getCuatrimestreActual(){
      this.$http.get("cuatrimestre_actual").then(
          response => {
            // console.log(response.data)
            this.cuatrimestre_actual = response.data.cuatrimestre_actual;
            //console.log(this.kardex);
            this.getCarreras();
            //
            //

          },
          error => {
            this.StepError(error);
          }
      );
    },
    
    getAlumnos() {
      let tokenStorage=localStorage.getItem('app-token');

      this.$http.post("alumnos_total",{token:tokenStorage}).then(
          response => {
            // console.log(response.data)
            this.alumnos = response.data.alumnos;
            //console.log(this.kardex);
            this.$vs.loading.close();
          },
          error => {
            if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
              this.$router.push({name:'pageLogin'});
              localStorage.clear();
              location.reload()
            }
            this.StepError(error);
          }
      );
    },
    getCarreras() {
      this.$http.get("carreras").then(
          response => {
            // console.log(response.data)
            this.carreras = response.data.carreras;
            //console.log(this.kardex);

          },
          error => {
            this.StepError(error);
          }
      );
      this.$http.get("carrera_id/" + this.carrera).then(
          response => {
            // console.log(response.data)
            this.carreras_select = response.data.carrera[0];
            //console.log(this.kardex);

          },
          error => {
            this.StepError(error);
          }
      );
    },
    // ver_materias(alumno){
    //   localStorage.setItem('matricula', alumno.matricula)
    //   localStorage.setItem('id', alumno.idAlumno)
    //   this.$router.push('/directores/materias_alumno_director')
    // },
    ver_kardex(alumno){
      localStorage.setItem('matricula', alumno.matricula)
      localStorage.setItem('id_alumno', alumno.id)

      this.$router.push('/directores/kardex')
    },

   getEstados(){
     
   
               
               this.$http.get("catalogos/get_estados").then(
                   response => {
                       this.estados = response.data.estados;
                        //this.modalEstatus=true;

                   },
                    error => {
                        this.StepError(error);
                    }
                );
                
            },
            //municipios
     getMunicipio(){
               
               this.$http.get("catalogos/get_municipios/"+this.formAlumno.estado_id.id).then(
                   response => {
                       this.municipios = response.data.municipios;
                           },
                    error => {
                        this.StepError(error);
                    }
                );
                
            },
            
    ver_estatus(id){
               
               this.$http.get("get_estatus_alumno/"+id).then(
                   response => {
                       this.formEstatus = response.data.estatus_alumno;
                        this.modalEstatus=true;

                   },
                    error => {
                        this.StepError(error);
                    }
                );
                
            },

  
  },
}
</script>